import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_CUISINE_TYPES } from '../action-types'

const cleanupCommonFetchCuisineTypes = createAction(
  COMMON_FETCH_CUISINE_TYPES.CLEANUP,
)

export default cleanupCommonFetchCuisineTypes
